export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";